import React, { useContext, useRef } from 'react';
import Share from 'components/Dashboard/components/Share';
import { store } from 'components/Store';
import calculateDifferenceBetweenDays from 'components/Dashboard/utilities/calculateDifferenceBetweenDays';
import useTitleScrolledStyles from 'components/Dashboard/hooks/useTitleScrolledStyles';
import TextSelector from 'components/Common/TextSelector';
import useCreateMarkup from 'components/Dashboard/hooks/useCreateMarkup';
import { useMainSectionParameter } from 'components/Dashboard/helpers/useMainSectionParameter';
import time from 'utils/time';
import RateUpdatesContentButton from 'components/Dashboard/RateUpdatesFeed/RateUpdatesContentButton';

const ShareButtonRender = (props) => {
  const { currentNew, shareButtonWidget, embed } = props;
  const { id, title, canonicalUrl, objectId, objectType } = currentNew;
  let item = {
    id,
    title,
    objectID: objectId,
    type: objectType,
  };
  const ShareOptions = {
    item,
    id: item.id,
    title: item.title,
    shareButtonWidget,
    itemShare: embed,
  };

  if (canonicalUrl) {
    ShareOptions.link = `${import.meta.env.VITE_APP_APPURL}${canonicalUrl}`;
  }

  return <Share {...ShareOptions} />;
};
const ConsultationNewContent = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { search } = state;

  const { activeSearch } = search;
  const {
    currentNew,
    shareButtonWidget,
    contentContainer,
    reportWidget,
    embed,
    scrollbarRef,
    scrolling,
    isFromPopup,
    notIncludeBranding,
    notShowShare,
  } = props;

  const { createMarkup } = useCreateMarkup();
  const { dashboardSection } = useMainSectionParameter();

  const consultationContentContainerRef = useRef(null);

  const renderText = () => {
    let days = calculateDifferenceBetweenDays(currentNew.closeDate);
    if (days >= 0) {
      return `Closing ${days === 0 ? 'today' : `in ${days} day${days === 1 ? '' : 's'}`}`;
    } else {
      return `Closed`;
    }
  };

  const returnTitleToRender = () => {
    if (activeSearch || shareButtonWidget) {
      return currentNew.titleHighlighted ?? currentNew.title;
    } else {
      return currentNew.title;
    }
  };

  const titleSection = useRef(null);
  let { showFixedTitle, titleStyles } = useTitleScrolledStyles({ contentContainer, titleSection });

  return (
    <div className='p-3 p-lg-4 pb-5 specific-content-container'>
      <div className='section-title consultation-content-title pb-2 mb-2' ref={titleSection}>
        <h3 className='main-title news-title pr-lg-4' dangerouslySetInnerHTML={createMarkup(returnTitleToRender())} />
        <div className='row mx-0 justify-content-between align-items-center'>
          {!!currentNew?.link && (
            <a
              className='legislation-source legislation-source-size mb-0'
              href={currentNew.link}
              target='_blank'
              rel='noopener noreferrer'
            >
              {reportWidget ? 'Source' : 'Go to source'}
            </a>
          )}
          {!notShowShare && (
            <div className='flex-centered'>
              {!notIncludeBranding && (
                <ShareButtonRender currentNew={currentNew} shareButtonWidget={shareButtonWidget} embed={embed} />
              )}
            </div>
          )}
        </div>
        <div className='my-2'>
          <RateUpdatesContentButton currentNew={currentNew} />
        </div>
      </div>

      {/* FIXED TITLE */}
      <div
        className={`content-item-scrolled-title section-title bg-white ${
          showFixedTitle && !isFromPopup && !reportWidget ? 'item-scrolled-title-visible' : ''
        }`}
        style={titleStyles}
      >
        <div className='d-flex justify-content-between scrolled-title-container'>
          <h3 className='main-title news-title pr-lg-4' dangerouslySetInnerHTML={createMarkup(returnTitleToRender())} />
          {!notShowShare && (
            <>
              {!notIncludeBranding && (
                <ShareButtonRender currentNew={currentNew} shareButtonWidget={shareButtonWidget} />
              )}
            </>
          )}
        </div>
      </div>
      {/* END FIXED TITLE */}
      <div
        className={`consultation-content-subtitle  d-flex justify-content-between consultation-content-key-dates ${
          dashboardSection ? 'mt-0 mb-3' : 'my-3'
        }`}
      >
        <h3 className='mb-0'>Key dates</h3>
        {currentNew.closeDate && (
          <p
            className={`text-right text-grey-description specific-right-padding-26 px-lg-3 mb-0 ${
              calculateDifferenceBetweenDays(currentNew.closeDate) > 7 ? '' : 'below-seven'
            }`}
          >
            <span
              className={`icon-clock pr-2 ${
                calculateDifferenceBetweenDays(currentNew.closeDate) > 7 ? 'blue-text' : ''
              } paragraph-p3`}
            ></span>
            {renderText()}
          </p>
        )}
      </div>
      <div className='pl-3 pl-lg-4 consultation-contente-dates'>
        <p className='open-consultation-datetitle mb-2'>
          <strong>Open date</strong>: <span>{time(currentNew.openDate).formatSlashDate()}</span>
        </p>
        {currentNew.closeDate !== null && currentNew.closeDate !== undefined && (
          <p className='open-consultation-datetitle mb-0'>
            <strong>Close date</strong>: <span>{time(currentNew.closeDate).formatSlashDate()}</span>
          </p>
        )}
      </div>
      <div className='consultation-content-subtitle my-3'>
        <h3 className='mb-0'>Summary</h3>
      </div>
      <TextSelector
        currentNew={currentNew}
        scrollbarRef={scrollbarRef}
        scrolling={scrolling}
        reportWidget={reportWidget}
      >
        <div
          ref={consultationContentContainerRef}
          className='news-content-in pt-2 pb-3 pr-3 context mb-2 consultation-content'
          dangerouslySetInnerHTML={createMarkup(currentNew.body)}
        ></div>
      </TextSelector>
    </div>
  );
};

export default ConsultationNewContent;
